import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 px-4 md:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20minimalist%20lifestyle%20product%20display%20with%20warm%20cream%20and%20sand%20tones%20clean%20organized%20shelves%20with%20sneakers%20and%20clothing%20items%20soft%20diffused%20golden%20hour%20lighting%20airy%20spacious%20atmosphere%20editorial%20style%20elegant%20minimal%20design%20modern%20retail%20vibe&width=1600&height=700&seq=kakobuy-cta-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet product showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 lg:gap-16">
          <div className="lg:w-1/2">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-white leading-tight">
              Ready to Start Shopping?
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-6">
              Access the largest free Kakobuy Spreadsheet directory today. Browse 20,000+ verified products, compare prices, and shop with confidence from trusted Yupoo sellers.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-white text-foreground-950 font-label font-semibold text-sm hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
              >
                Start Shopping
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/what-is-kakobuy-spreadsheet"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-label font-semibold text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}